export default __webpack_public_path__ + "static/tendril-back-72f7b336b4ff54239492fcdabab2aabd.jpg";